import { Routes } from "@angular/router";
import { authGuard, guestGuard } from "../auth.guard";
import { MainLayout } from "../layout/main-layout";

export const routes: Routes = [
  {
    path: "",
    component: MainLayout,
    children: [
      {
        path: "",
        title: "Asah Skill",

        canActivate: [guestGuard],
        loadComponent: () =>
          import("./landing/landing").then((m) => m.LandingPage),
      },
      {
        path: "activate-account",
        title: "Activate Account",
        loadComponent: () =>
          import("./activate-account/activate").then(
            (m) => m.ActivateAccountPage
          ),
      },
      {
        path: "home",
        title: "Home Dashboard",
        canActivate: [authGuard],
        loadComponent: () => import("./home/home").then((m) => m.HomePage),
      },
      {
        path: "profile",
        title: "Profil Saya",
        canActivate: [authGuard],
        loadComponent: () =>
          import("./profile/profile").then((m) => m.ProfilePage),
      },
      {
        path: "courses",
        title: "All Courses",
        canActivate: [authGuard],
        loadComponent: () =>
          import("./courses/courses").then((m) => m.CoursesPage),
      },
      {
        path: "courses/detail/:id",
        title: "Course Detail",
        canActivate: [authGuard],
        loadComponent: () =>
          import("./course-detail/course-detail").then(
            (m) => m.CourseDetailPage
          ),
      },
      {
        path: "upcoming-event/:id",
        title: "Detail Acara",
        loadComponent: () =>
          import("./upcoming-event-detail/upcoming-event-detail").then(
            (m) => m.UpcomingEventDetailPage
          ),
      },
      {
        path: "my-course/:type/:id",
        title: "Detail Kursus Saya",
        canActivate: [authGuard],
        loadComponent: () =>
          import("./my-course-detail/my-course-detail").then(
            (m) => m.MyCourseDetailPage
          ),
      },
      {
        path: "session-detail/:id",
        title: "Detail Sesi Pelatihan",
        canActivate: [authGuard],
        loadComponent: () =>
          import("./session-detail/session-detail").then(
            (m) => m.SessionDetailPage
          ),
      },
      {
        path: "events",
        title: "Ikuti Event",
        canActivate: [authGuard],
        loadComponent: () =>
          import("./events/events").then((m) => m.EventsPage),
      },
      {
        path: "payment/history",
        title: "Payment History",
        canActivate: [authGuard],
        loadComponent: () =>
          import("./payment-history/payment-history").then(
            (m) => m.PaymentHistoryPage
          ),
      },
      {
        path: "payment/success",
        title: "Payment Successful",
        loadComponent: () =>
          import("./payment-success/payment-success").then(
            (m) => m.PaymentSuccessPage
          ),
      },
      {
        path: "payment/failed",
        title: "Payment Failed",
        loadComponent: () =>
          import("./payment-failed/payment-failed").then(
            (m) => m.PaymentFailedPage
          ),
      },
    ],
  },
  {
    path: "**",
    redirectTo: "",
  },
];
